import React, { ReactNode } from 'react';

import ContractsGrid from './components/ContractGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import Loader from '../../../../../../../../components/Loader';
import { IContract } from 'src/types/contract';
import { IStudent } from 'src/types/student';
import classNames from 'classnames';
import styles from '../../../../../ServiceTypes/screens/ServiceTypeList/assets/serviceType-list-screen.module.scss';
import CreateContractButton from './components/CreateContractButton';

export interface StateProps {
    data: Paginated<IContract>;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {
    student: Partial<IStudent> | null;
    tab: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ContractList extends React.Component<Props> {
    public render(): ReactNode {
        const { data, getData, inProgress, student, tab } = this.props;

        return (
            <div style={{ padding: '30px 0' }}>
                {inProgress ? <Loader /> : null}
                <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                    <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                        Contracts {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    <CreateContractButton student={`${student?.id}`} />
                </div>
                <ContractsGrid student={`${student?.id}`} data={data} getData={getData} />
            </div>
        );
    }
}

export default ContractList;
